/** Share one in-flight promise per key — avoids duplicate parallel API calls. */
const inFlight = new Map<string, Promise<unknown>>()

export function dedupeRequest<T>(key: string, fn: () => Promise<T>): Promise<T> {
  const existing = inFlight.get(key)
  if (existing) {
    return existing as Promise<T>
  }
  const promise = fn().finally(() => {
    inFlight.delete(key)
  })
  inFlight.set(key, promise)
  return promise
}

export function clearDedupeRequest(key: string): void {
  inFlight.delete(key)
}

export function clearAllDedupeRequests(): void {
  inFlight.clear()
}
